import i18nFactory from '@yandex-int/i18n';
import { PopupDirection } from 'lego-on-react';
import { isUndefined } from 'lodash';
import * as React from 'react';

import { ChangeFeedFilterRatePayload } from '../../actions/feed-filters/rate-form';
import { FeedFilterRateFormContainer } from '../../containers/FeedFilterRateFormContainer/FeedFilterRateFormContainer';
import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { TestBem } from '../../service/TestBem';
import { BasePopupProps } from '../../typings/common';
import { FeedFilterRateType } from '../../typings/feedFilters';
import { EditableCell } from '../EditableCell/EditableCell';
import { MoneyText } from '../MoneyText/MoneyText';
import { PopupDecorator } from '../PopupDecorator/PopupDecorator';

import * as keyset from './FeedFilterRateCellEditor.i18n';

export interface FeedFilterRateCellEditorProps {
    isSaving: boolean;
    error?: string;
    rate?: number;
    fixedRateType: FeedFilterRateType;
    cellName: string;
    feedFilterId: string;
    onCancel: () => void;
    onSave: (rateType: FeedFilterRateType) => void;
    onInitialValuesSet: (payload: ChangeFeedFilterRatePayload) => void;
}

type FeedFilterRateCellEditorBaseProps = FeedFilterRateCellEditorProps &
    BasePopupProps;

const i18n = i18nFactory(keyset);

const POPUP_DIRECTIONS: Array<PopupDirection> = [
    'bottom-center',
    'top-center',
    'left-center',
    'right-center'
];

const BLOCK = 'feed-filter-rate-cell-editor';

class FeedFilterRateCellEditorBase extends React.Component<
    FeedFilterRateCellEditorBaseProps
> {
    componentDidUpdate(prevProps: FeedFilterRateCellEditorBaseProps) {
        if (
            (prevProps.isSaving !== this.props.isSaving ||
                prevProps.error !== this.props.error) &&
            !this.props.isSaving &&
            !this.props.error
        ) {
            this.props.closePopup();
        }
    }

    render() {
        const { rate, isPopupVisible, cellName, feedFilterId } = this.props;

        return (
            <>
                <EditableCell
                    cls={TestBem.cls({
                        block: BLOCK,
                        mods: {
                            name: cellName,
                            id: feedFilterId
                        }
                    })}
                    onClick={this.onTogglePopup}
                    isActive={isPopupVisible}
                >
                    {rate ? <MoneyText num={rate} /> : i18n('empty-rate')}
                </EditableCell>
                {this.getPopup()}
            </>
        );
    }

    private onTogglePopup = () => {
        const {
            rate,
            isPopupVisible,
            switchPopupState,
            onInitialValuesSet
        } = this.props;

        switchPopupState();

        if (!isPopupVisible) {
            onInitialValuesSet({ rate: !isUndefined(rate) ? rate : 0 });
        }
    };

    private onPopupClose = () => {
        const { closePopup, onCancel } = this.props;

        closePopup();
        onCancel();
    };

    private getPopup = () => {
        const {
            isSaving,
            isPopupVisible,
            fixedRateType,
            onSave,
            feedFilterId
        } = this.props;

        return (
            <PopupDecorator
                cls={TestBem.cls(BLOCK, 'popup', {
                    id: feedFilterId
                })}
                onOutsideClick={this.onPopupClose}
                anchor={this}
                visible={isPopupVisible}
                target="anchor"
                directions={POPUP_DIRECTIONS}
                header={i18n('title')}
                hasTail={true}
            >
                <FeedFilterRateFormContainer
                    isLoading={isSaving}
                    fixedRateType={fixedRateType}
                    onCancel={this.onPopupClose}
                    onSave={onSave}
                />
            </PopupDecorator>
        );
    };
}

export const FeedFilterRateCellEditor = makeGridPopupContainer<
    FeedFilterRateCellEditorProps
>(FeedFilterRateCellEditorBase);
